<script>
export default {
  props: ['value', 'numberOfFounders'],
  data() {
    return {
      founders: [{}],
    }
  },
  mounted() {
    if (this.value && this.value.length > 0) {
      this.founders = this.value.concat([]);
    }

    if (this.numberOfFounders) {
      this.changeFounderNumber(this.numberOfFounders);
    }
  },
  updated() {

  },
  methods: {
    remove(index) {
      this.founders.splice(index, 1);
    },
    changeFounderNumber(_number) {
      // we want to keep the current on remove / add
      let newFounders = [];
      for (let i = 0; i < _number; i++) {
        newFounders.push({});
      }

      // copy current
      for (let i = 0; i < _number; i++) {
        if (this.founders[i]) {
          newFounders[i] = this.founders[i];
        }
      }
      this.founders = newFounders;
    },
  },
  computed: {},
  watch: {
    numberOfFounders(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.changeFounderNumber(newVal);
      }
    },
    founders(newVal, oldVal) {
      this.$emit('input', newVal);
    },
  }
};
</script>

<template>
  <div class="fund-use-input">
    <div class="title-md">
      Founders
    </div>
    <div class="sep-8"></div>
    <h3 class="light">
      Please add founder(s) details
    </h3>
    <div class="sep-8"></div>
    <div v-for="(item, index) in founders">
      <div class="columns" :key="'f1'+index">
        <div class="column is-5">
          <div class="control">
            <div class="field small-label">
              <label class="label">
                Founder Name
              </label>
              <input placeholder="Founder Name" style="width: auto" vrules="required" type="text" class="input"
                     v-model="item.name">
              <div class="vrule help is-danger" rule="required">
                This field is required.
              </div>
            </div>
          </div>
        </div>
        <div class="column is-5">
          <div class="control">
            <div class="field small-label">
              <label class="label">
                Email
              </label>
              <input placeholder="Email" style="width: auto" vrules="email|required" type="text" class="input"
                     v-model="item.email">
              <div class="vrule help is-danger" rule="email">
                Please enter a valid email.
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="clear-share-holder" v-if="index>0" @click="remove(index)">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                 style="enable-background:new 0 0 24 24;" xml:space="preserve">

                        <g id="Close">
                            <polygon id="Fill-2" class="st0" points="18,7.4 16.6,6 12,10.6 7.4,6 6,7.4 10.6,12 6,16.6 7.4,18 12,13.4 16.6,18 18,16.6
                                13.4,12 	"/>
                        </g>
                    </svg>

          </div>
        </div>
      </div>
      <div class="columns" :key="'f2'+index">
        <div class="column is-5">
          <div class="control">
            <div class="field small-label">
              <label class="label">
                Linked In Profile URL
              </label>
              <input placeholder="Linked In" style="width: auto" vrules="website" type="text" class="input"
                     v-model="item.linkedin">
              <div class="vrule help is-danger" rule="website">
                Please enter a valid URL.
              </div>
            </div>
          </div>
        </div>
        <div class="column is-5">
          <div class="control">
            <div class="field small-label">
              <label class="label">
                Field of Expertise
              </label>
              <input placeholder="Field of Expertise" style="width: auto" vrules="required" type="text" class="input"
                     v-model="item.expertise">
              <div class="vrule help is-danger" rule="required">
                This field is required.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sep-16"></div>


  </div>
</template>

<style lang="scss" scoped>
@import "../../../style/vars";

.fund-use-input {
  padding: 0px;
}

.percentage-label {
  margin-top: 7px;
}

.add-shareholder {
  font-weight: bold;
  cursor: pointer;
  color: $primary;
  margin-bottom: 15px;
}

.input-group {
  .input-group-text {
    border-left: none;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}

.clear-share-holder {
  line-height: 60px;
  cursor: pointer;
  position: relative;
  top: 32px;

  svg {
    width: 24px;
    height: 24px;
    fill: #A7ACB2;
  }
}

.icon-control input {
  width: 60px;
}
</style>
